import { EmeshApiClient } from "../client";
import { PostUserPassResponse, PostUserPassErrorResponse } from "./types";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import { AxiosResponse } from "axios";
const emeshApiClient: EmeshApiClient = new EmeshApiClient("/v1/user/pass");

export async function postUserPassApi(params: {
  loginId: string;
  oldPass: string;
  newPass: string;
  newPassVerification: string;
}): Promise<PostUserPassResponse | PostUserPassErrorResponse> {
  return await emeshApiClient
    .post(
      {
        headers: {
          Authorization: getBearerToken()
        }
      },
      {
        login_id: params.loginId,
        old_pass: params.oldPass,
        new_pass: params.newPass,
        new_pass_verification: params.newPassVerification
      }
    )
    .then((resp: AxiosResponse<PostUserPassResponse>) => {
      return Promise.resolve(resp.data as PostUserPassResponse);
    })
    .catch(e => {
      if (e.status === 400) {
        return Promise.reject("パスワードが正しくありません");
      }
      if (e.data) return Promise.reject(e.data as PostUserPassErrorResponse);
      return Promise.reject(e);
    });
}
